export default __webpack_public_path__ + "static/media/teaser-template.ad2c815c.svg";